import { render, staticRenderFns } from "./FormRatingClearButton.vue?vue&type=template&id=5d0f1c6b&"
import script from "./FormRatingClearButton.vue?vue&type=script&lang=js&"
export * from "./FormRatingClearButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports